import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { PageContext } from "../../../../Context/PageContext";
import { ApiConnectMessageListRequest, ApiConnectMessageReadStatusUpdate } from "../../../../api/LionsUserApiConect";
import ReadIcon from "../meucadastro/img/mailread.png"
import UnreadIcon from "../meucadastro/img/mailunread.png"
import ColorEmailIcon from "../meucadastro/img/emailcolor.png"
import { OpenPopMenu } from "../../../../PopMenuWindow/PopMenuWindow";
import MessageLetter from "./message/MessageLetter";
import UserNotLogged from "../UserNotLogged";

function MessageListLog() {

    const { user, setPage, setIsLogged} = useContext(PageContext);
    const {setPopMenuContent} = useContext(PageContext)

    const [messageList, setMessageList] = useState([])
    const [dateRule, setDateRule] = useState("-")
    const [topicRule, setTopicRule] = useState("")

    useEffect(() => {
        let result = ApiConnectMessageListRequest(user.userName, user.userEmail)
        result.then(response =>{ 
            
            if(response.status == 403 || response.status == 401) {
                setPage(<UserNotLogged />);
                setIsLogged(false);
                return;
            }
            if(response.data == false){
                setMessageList([]);
                setTimeout(() => document.getElementById("Master").style.opacity = 1,300)
                return;
            }
            setTimeout(() => document.getElementById("Master").style.opacity = 1,300)
            setMessageList(response.data)});
        }
        ,[])

    return(
        <MessageContainer id="Master">

                <TitleMaster>
                    <ColumItemHeaderIcon iconImg={ColorEmailIcon}/>
                    <TitleFont>Mensagens </TitleFont>
                </TitleMaster>

                <MessageHeader>
                    <MessageHeaderItem>
                        <Select onChange={(e) => setDateRule(e.target.value)}>
                            <Option value="-">Data</Option>
                            <Option value="2024">2024</Option>
                            <Option value="2025">2025</Option>
                        </Select>
                    </MessageHeaderItem>

                    <MessageHeaderItem>
                        <Select onChange={(e) => setTopicRule(e.target.value)}>
                            <Option value="">Todos</Option>
                            <Option value="unread">novo</Option>
                            <Option value="read">antigo</Option>
                        </Select>
                    </MessageHeaderItem>

                </MessageHeader>

                <MessageItemsMaster>
                    {messageList.map((item) => {
                        if(item.readStatus.includes(topicRule) === false){
                            return;
                        }
                        if(item.messageDate.includes(dateRule) === false){
                            return;
                    }

                        let iconImage = ""

                        if(item.readStatus.includes("un")) { iconImage = UnreadIcon} else 
                        if(item.readStatus.includes("read")) { iconImage = ReadIcon}

                        return(
                        <MessageItem
                        onClick={() => {
                                    OpenPopMenu();
                                    if(item.readStatus === "unread") {
                                        item.readStatus = "read";
                                        ApiConnectMessageReadStatusUpdate(item)};
                                    setPopMenuContent(
                                    <MessageLetter 
                                    messageFrom={item.messageAutor}
                                    content={item.messageContent}
                                    name={item.messageUserName}
                                    title={item.messageTitle}/>);
                                }}>
                            <MessageIconField>
                                <MessageNumberField>#{messageList.indexOf(item) + 1}</MessageNumberField>
                                <MessageReadStatusIcon 
                                iconImg={iconImage}
                                />
                                
                            </MessageIconField>
                            <MessageField>{item.messageAutor}</MessageField>
                            <MessageField>{item.messageTitle}</MessageField>
                            <MessageField>{item.messageDate}</MessageField>
                            
                        </MessageItem>
                        )
                    })}

                </MessageItemsMaster>
                </MessageContainer>

    )
}

export default MessageListLog;

const MessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    //border: solid;
    margin-top: 50px;
    border-radius: 10px;
    //box-shadow: 0 0 10px 0 black;
    padding: 0px 0px;
    max-height: 1000px;
    transition: .5s ease-in-out;
    opacity: 0;
    margin-bottom: 1000px;

     @media(max-width: 1000px) {
      width: 90vw;
      padding: 40px 15px;
      //border: solid 1px rgba(0,0,0, .2);
    }
    

`

const TitleMaster = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    border-radius: 10px;
    transition: .3s ease-in-out;
    margin: 20px 0;
    //border: solid;
    background-color: rgba(0,0,0,.7);
    color: white;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    @media(max-width: 1000px) {
      width: 90vw;
      padding: 0 0px;
    }

`

const TitleFont = styled.span`
    font-size: 24pt;
    font-weight: bold;
    margin: 25px 0;

    @media(max-width: 1000px) {
      font-size: 20pt
    }

`

const ColumItemHeaderIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 45px;
    height: 45px;
    margin: 0 55px;
`

const MessageHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 0px 0px;
    width: 100%;
    margin: 10px 0;
    //border: solid;
    //background-color: rgba(0,0,0,.7);

    @media(max-width: 1000px) {
        margin-bottom: 20px;
    }

`

const MessageHeaderItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 12pt;
    transition: .3s ease-in-out;
    padding: 10px 0px;
    margin: 0 25px 0 0;
    border-radius: 5px;
    background-color: rgba(0,0,0,.7);
    color: white;
    width: 200px;

    @media(max-width: 1000px) {
      font-size: 12pt;
    }

`

const MessageItemsMaster = styled.div`
    display: flex;
    align-items: start;
    flex-wrap: wrap;
    //border: solid;
    background-color: rgba(0,0,0,.7);
    margin: 10px 0;
    border-radius: 5px;
    width: 100%;
    overflow: auto;
    padding: 5px 0;
`

const MessageItem = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 190px;
    //justify-content: space-between;
    font-size: 12pt;
    transition: .3s ease-in-out;
    cursor: pointer;
    background-color: rgba(0,0,0,.7);
    border-radius: 5px;
    margin: 20px 5px;
    padding: 10px;

    &:hover {
        scale: 1.1;
    }

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    @media(max-width: 1000px) {
      width: 100%;
    }
`

const MessageIconField = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .3s ease-in-out;
    padding: 20px 0px;
    text-align: center;
    //border: solid;
    margin: 10px 0px;
    width: 160px;
    height: 100px;
    color: white;
    background-color: rgba(0,0,0,.7);
    border-radius: 5px;
    position: relative;

`

const MessageReadStatusIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 45px;
    height: 45px;
    transition: .3s ease-in-out;
`

const MessageNumberField = styled.div`
    display: flex;
    align-items: center;
    transition: .3s ease-in-out;
    padding: 0px 0px;
    text-align: center;
    //border: solid;
    color: white;
    //background-color: rgba(0,0,0,.7);
    border-radius: 5px;
    position: absolute;
    top: 5px;
    left: 10px;
    font-weight: bold;

`

const MessageField = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .3s ease-in-out;
    padding: 0px 0px;
    text-align: center;
    //border: solid;
    margin: 0px 0px;
    width: 160px;
    color: white;
    //background-color: rgba(0,0,0,.7);
    border-radius: 5px;

`

const Select = styled.select`
    border: none;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-size: 14pt;
    transition: .3s ease-in-out;
    background-color: transparent;
    color: white;
    width: 100%;
    border: none;
    font-weight: bold;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }
`
const Option = styled.option`
    background-color: rgba(0,0,0,.7);
    color: white;
    
`



